import ApiService from '@/services/api.service'

const EligibilityService = {
    checkEligible(id) {
        return ApiService.get(`Eligibility/eligible?id=${id}`)
    },
    createEligibilityHtml(data) {
        return ApiService.getData(`Eligibility/eligibility?PatientCode=${data.PatientCode}&InsuranceCode=${data.InsuranceCode}&ServiceDate=${data.ServiceDate}`)
    },

    getEligibilityHtml(data) {
        return ApiService.get(`Eligibility/eligibilityReport?PatientCode=${data.PatientCode}&InsuranceCode=${data.InsuranceCode}`)
    },

    createGroupEligibility(data) {
        return ApiService.post(`Eligibility/groupEligibility`, data)
    },

    monitorEligibility(parameter) {
        return ApiService.getWithArray(`Eligibility/monitor`, parameter)
    }
}

export default EligibilityService